import React from 'react';
import PageHelmet from '../components/PageHelmet';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const NotFound = () => {
  return (
    <section style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <PageHelmet
        title={`404 Not Found — OneAI`}
        description={`The page you requested was not found. Explore OneAI tools like the Humanizer, Blog Builder, and more.`}
  canonical={window.location.origin + normalizeRoute('/404')}
      />
      <h1 style={{ fontSize: '1.75rem', marginBottom: 12 }}>404 — Page not found</h1>
      <p style={{ color: '#374151' }}>
        Sorry, we couldn't find the page you were looking for. Try one of the links below or go back to the Humanizer.
      </p>

      <div style={{ marginTop: 18, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
  <a href={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Humanizer</a>
  <a href={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Blog</a>
  <a href={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact</a>
  <a href={normalizeRoute(ROUTES.about.path)} className="btn ghost">About</a>
      </div>
    </section>
  );
};

export default NotFound;
